import script from "./PriceCategoriesForSecondAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCategoriesForSecondAgent.vue?vue&type=script&setup=true&lang=js"

import "./PriceCategoriesForSecondAgent.vue?vue&type=style&index=0&id=c0431ccc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0431ccc"]])

export default __exports__